import AbstractRequestTask from '../AbstractRequestTask';
import Launcher from '../../apa/Launcher';
import DeviceStorage from '../../../components/DeviceStorage/DeviceStorage';
import {DISABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import pkg from "../../../../package.json";
import logger from 'src/utils/logger/logger';
class EpgVersionTask extends AbstractRequestTask {
  getUrl() {
    const http = 'https://';
    const url = Launcher.get('akamai_mfwk');
    return `${http}${url}/services/epg/version`;
    // return "http://10.7.1.205:6001/epg/version";
  }

  getSTBAPKVersion() {
    let ua = navigator.userAgent;
    let apkversion = null;
    if(ua) {
        let re = /(\d{3,})$/g;
        let res = re.exec(ua);
        if(res && res[1]) {
            apkversion = parseInt(res[1]);
        }
    }
  return apkversion
}

  getParams() {
    const defaultParams = super.getParams();
    const subregion = DeviceStorage.getItem('sub_region');
    const soa_version = DeviceStorage.getItem('soaVersion');
    const app_version = DeviceStorage.getItem('appVersionApi');
    const epg_version = DeviceStorage.getItem('epgVersion');
    const app_installed  = pkg.version;
    const apk_version = this.getSTBAPKVersion();

    const params = {
      ...defaultParams,
      subregion,
      soa_version,
      app_version,
      epg_version,
      app_installed,
      apk_version
    };
    delete params.user_token;

    return params;
  }

  success(data, b) {
    this.resolve(data);
  }

  parseErrors(err) {
    logger.debug('Parser errors en appVersion');
  }

  getShowErrorModal(){
    return DISABLE_MODAL_RETRIES;
  }

  isValid(data) {
    return data;
  }

  getRetriesNumber() {
    return 0;
  }
}

export default EpgVersionTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/application/EpgVersionTask.js